import(/* webpackMode: "eager" */ "/vercel/path0/src/app/guides/page.tsx");
